var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5H12M15 22.5H12M24 10.5H12M30 15V10.2C30 7.67976 30 6.41965 29.5095 5.45704C29.0781 4.61031 28.3897 3.9219 27.543 3.49047C26.5804 3 25.3202 3 22.8 3H13.2C10.6798 3 9.41965 3 8.45704 3.49047C7.61031 3.9219 6.9219 4.61031 6.49047 5.45704C6 6.41965 6 7.67976 6 10.2V25.8C6 28.3202 6 29.5804 6.49047 30.543C6.9219 31.3897 7.61031 32.0781 8.45704 32.5095C9.41965 33 10.6798 33 13.2 33H18.75M27 31.5C27 31.5 31.5 29.3551 31.5 26.1378V22.3843L28.2186 21.2118C27.4302 20.9294 26.568 20.9294 25.7796 21.2118L22.5 22.3843V26.1378C22.5 29.3551 27 31.5 27 31.5Z",
    stroke: "#963A72",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycShield);
export default __webpack_public_path__ + "static/media/kyc-shield.7fafca293d4f594766c57e21174c31aa.svg";
export { ForwardRef as ReactComponent };